"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartContainer = ChartContainer;
var _react = _interopRequireDefault(require("react"));
var _ChartContainer = require("./ChartContainer.styled");
var _ErrorBoundary = require("./ErrorBoundary");
var _ChartDate = _interopRequireDefault(require("./ChartDate"));
var _ChartSource = _interopRequireDefault(require("./ChartSource"));
var _TextChart = _interopRequireDefault(require("../charts/TextChart"));
var _LineChart = _interopRequireDefault(require("../charts/LineChart"));
var _DonutChart = _interopRequireDefault(require("../charts/DonutChart"));
var _StackedBarChart = _interopRequireDefault(require("../charts/StackedBarChart"));
var _ScatterPlot = _interopRequireDefault(require("../charts/ScatterPlot"));
var _BarChart = _interopRequireDefault(require("../charts/BarChart"));
var _BeeswarmChart = _interopRequireDefault(require("../charts/BeeswarmChart"));
var _VennDiagram = _interopRequireDefault(require("../charts/VennDiagram"));
var _HorizontalBarChart = _interopRequireDefault(require("../charts/HorizontalBarChart"));
var _TableChart = _interopRequireDefault(require("../charts/TableChart"));
var _ErrorPlaceholder = _interopRequireDefault(require("../charts/ErrorPlaceholder"));
var _StackedHorizontalBarChart = _interopRequireDefault(require("../charts/StackedHorizontalBarChart"));
var _BubbleMap = _interopRequireDefault(require("../charts/BubbleMap"));
var _ChoroplethMap = _interopRequireDefault(require("../charts/ChoroplethMap"));
var _ConnectionMap = _interopRequireDefault(require("../charts/ConnectionMap"));
var _SankeyDiagram = _interopRequireDefault(require("../charts/SankeyDiagram"));
const chartComponents = {
  text_chart: _TextChart.default,
  error_placeholder: _ErrorPlaceholder.default,
  stacked_bar_chart: _StackedBarChart.default,
  stacked_horizontal_bar_chart: _StackedHorizontalBarChart.default,
  horizontal_bar_chart: _HorizontalBarChart.default,
  donut_chart: _DonutChart.default,
  bar_chart: _BarChart.default,
  line_chart: _LineChart.default,
  choropleth_map: _ChoroplethMap.default,
  bubble_map: _BubbleMap.default,
  connection_map: _ConnectionMap.default,
  scatter_plot: _ScatterPlot.default,
  beeswarm_chart: _BeeswarmChart.default,
  venn_diagram: _VennDiagram.default,
  sankey_diagram: _SankeyDiagram.default,
  table_chart: _TableChart.default
};
function ChartContainer(_ref) {
  let {
    chart,
    layout,
    report,
    parentFilter,
    theme,
    isPreview = false
  } = _ref;
  const ChartComponent = chartComponents[chart.component];
  return /*#__PURE__*/_react.default.createElement(_ErrorBoundary.ErrorBoundary, null, /*#__PURE__*/_react.default.createElement(_ChartContainer.ChartWrapper, {
    spanRow: chart.spanRow,
    id: chart.id
  }, /*#__PURE__*/_react.default.createElement(_ChartContainer.ChartTitle, {
    color: theme.colors.main,
    layout: layout
  }, chart.title, " ", chart.showYearRange && /*#__PURE__*/_react.default.createElement(_ChartDate.default, {
    data: chart.dataView.data,
    theme: theme
  })), /*#__PURE__*/_react.default.createElement(ChartComponent, {
    chart: chart,
    layout: layout,
    chartColors: report.theme.colors,
    theme: theme,
    boundaries: report.boundaries,
    geography: report.geography,
    isDraft: report.isDraft,
    isPreview: isPreview,
    animate: !isPreview && layout === "screen",
    parentFilter: parentFilter
  }), /*#__PURE__*/_react.default.createElement(_ChartSource.default, {
    source: chart.dataView.source
  })));
}